import { type PinterestAdsConnectorConfig } from 'shared/thirdParty/fivetran/platforms/pinterest_ads'
import { type ConnectorResponseData, type SyncMode } from 'shared/thirdParty/fivetran/types'

export const PLATFORM = {
  PINTEREST_ADS: 'pinterest_ads'
} as const

export type SupportedPlatform = (typeof PLATFORM)[keyof typeof PLATFORM]

export type GetResponseConfigSyncMode = (config: ConnectorResponseData['config']) => SyncMode

export type FivetranConnectorConfig = PinterestAdsConnectorConfig
